/* DocFinder · Cinematic Enhancement · ergänzt docfinder.js — ändert keine Kernfunktion */
(function() {
  var sec = document.getElementById('docfinder-custom');
  if (!sec) return;

  var resultsEl = document.getElementById('docfinder-results');
  if (!resultsEl) return;

  /* Cursor-Glow auf Cards (Stufe 3) */
  function attachCursorGlow() {
    var cards = resultsEl.querySelectorAll('.docfinder-card');
    cards.forEach(function(card) {
      if (card.dataset.glowAttached) return;
      card.dataset.glowAttached = '1';
      card.addEventListener('mousemove', function(e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        card.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  /* MutationObserver: jedes Mal wenn JS Cards neu rendert, Glow neu attachen */
  var mo = new MutationObserver(attachCursorGlow);
  mo.observe(resultsEl, { childList: true });
  attachCursorGlow();

  /* Stagger-Reveal Delay: setzt animation-delay basierend auf Card-Index */
  function staggerCards() {
    var cards = resultsEl.querySelectorAll('.docfinder-card');
    cards.forEach(function(card, i) {
      card.style.animationDelay = Math.min(i * 50, 600) + 'ms';
    });
  }
  var mo2 = new MutationObserver(staggerCards);
  mo2.observe(resultsEl, { childList: true });
  staggerCards();
})();
